import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  CardActions, 
  Button 
} from '@mui/material';
import { Playlist } from '../../models';

interface PlaylistListProps {
  playlists: Playlist[];
  onViewDetails: (playlistId: string) => void;
}

const PlaylistList: React.FC<PlaylistListProps> = ({ playlists, onViewDetails }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Your Playlists</Typography>
      <Grid container spacing={2}>
        {playlists.map((playlist) => (
          <Grid item xs={12} sm={6} md={4} key={playlist.id}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1">{playlist.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {playlist.description || 'No description'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {playlist.totalTracks} tracks
                </Typography>
              </CardContent>
              <CardActions>
                <Button 
                  size="small" 
                  onClick={() => onViewDetails(playlist.id)}
                >
                  View Details
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PlaylistList;
